import React from "react";
import ReactDOM from "react-dom";

interface ConfirmYesNoProps {
    message: string;
    resolve: (result: boolean) => void;
}

const ConfirmYesNoComponent: React.FC<ConfirmYesNoProps> = ({ message, resolve }) => {
    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.3)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999
            }}
        >
            <div
                style={{
                    background: "#fff",
                    padding: 20,
                    borderRadius: 8,
                    minWidth: 320,
                    boxShadow: "0 2px 10px rgba(0,0,0,0.2)"
                }}
            >
                <h2 style={{ marginBottom: 20, textAlign: "center", fontSize: "20px", fontWeight: "bold", color: "#ae4540", borderBottom: "2px solid #ffc843", paddingBottom: 10 }}>Confirm</h2>
                <p style={{ marginBottom: 20 }}>{message}</p>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                        onClick={() => resolve(true)}
                        style={{
                            backgroundColor: "#00607f",
                            color: "#fff",
                            border: "none",
                            padding: "8px 16px",
                            borderRadius: 4,
                            cursor: "pointer"
                        }}
                    >
                        Yes
                    </button>

                    <button
                        onClick={() => resolve(false)}
                        style={{
                            backgroundColor: "#00607f",
                            color: "#fff",
                            border: "none",
                            padding: "8px 16px",
                            borderRadius: 4,
                            cursor: "pointer",
                            marginLeft: 10
                        }}
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    );
};

export default function confirmYesNo(message: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
        const div = document.createElement("div");
        document.body.appendChild(div);

        const handleResolve = (result: boolean) => {
            ReactDOM.unmountComponentAtNode(div);
            div.remove();
            resolve(result);
        };

        ReactDOM.render(
            <ConfirmYesNoComponent message={message} resolve={handleResolve} />,
            div
        );
    });
}